// import classServices from 'ApiService/Student/classServices';
// import Card from 'components/card';
// import { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';

// const Index = () => {
//   const [loading, setLoading] = useState(true);
//   const [details, setDetails] = useState([]);

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//     });
//   };

//   const fetchCourses = async () => {
//     setLoading(true);
//     try {
//       const response = await classServices.getBatchDetails();
//       if (response.data.success) {
//         setDetails(response.data.batches || []);
//         setLoading(false);
//       } else {
//         toast.error('Failed to fetch batch details.');
//         setLoading(false);
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || 'Failed to fetch batch details.'
//       );
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCourses();
//   }, []);

//   if (loading) {
//     return (
//       <Card extra={'w-full sm:overflow-auto p-4'}>
//         <div className="flex h-40 items-center justify-center">
//           <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
//         </div>
//       </Card>
//     );
//   }

//   return (
//     <Card extra={'w-full sm:overflow-auto p-4'}>
//       <div className="space-y-4">
//         {details.map((batch) => (
//           <div
//             key={batch._id}
//             className="rounded-lg border p-4 text-navy-800 shadow-sm transition-shadow duration-300 hover:shadow-md dark:text-white/70"
//           >
//             <div className="mb-4 flex items-center justify-between">
//               <h2 className="text-xl font-bold text-gray-800 dark:text-white">
//                 {batch.course.courseName} - Batch {batch.batchNumber}
//               </h2>
//               {batch.isCurrent ? (
//                 <>
//                   <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
//                     Current
//                   </span>
//                 </>
//               ) : (
//                 <>
//                   <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800">
//                     Past
//                   </span>
//                 </>
//               )}
//             </div>

//             <div className="grid gap-4 md:grid-cols-2">
//               {/* Batch Details */}
//               <div className="space-y-2">
//                 <div className="flex items-center space-x-2">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 text-green-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                     />
//                   </svg>
//                   <span>Start Date: {formatDate(batch.startDate)}</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 text-red-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   <span>End Date: {formatDate(batch.endDate)}</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 text-purple-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   <span>
//                     Time: {batch.startTime || 'N/A'} - {batch.endTime || 'N/A'}
//                   </span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 text-blue-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
//                     />
//                   </svg>
//                   <span>Students Enrolled: {batch.studentsEnrolled}</span>
//                 </div>
//               </div>

//               {/* Days Schedule */}
//               {batch.days && batch.days.length > 0 && (
//                 <div>
//                   <h3 className="mb-2 text-lg font-semibold text-gray-700">
//                     Class Days
//                   </h3>
//                   <div className="grid grid-cols-2 gap-2">
//                     {batch.days.map((day) => (
//                       <div
//                         key={day}
//                         className="rounded bg-gray-100  px-3 py-1 text-center text-gray-800 dark:border dark:bg-navy-800 dark:text-white"
//                       >
//                         {day}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Teacher Information */}
//             {batch.teacher && (
//               <div className="mt-4 border-t border-gray-200 pt-2">
//                 <h3 className="text-lg font-semibold text-gray-700">
//                   Instructor
//                 </h3>
//                 <div className="flex items-center space-x-2">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 text-indigo-600"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a4 4 0 00-4 4v1h8v-1a4 4 0 00-4-4z"
//                     />
//                   </svg>
//                   <span>
//                     {batch.teacher.name} ({batch.teacher.email})
//                   </span>
//                 </div>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </Card>
//   );
// };

// export default Index;
import classServices from 'ApiService/Student/classServices';
import Card from 'components/card';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const Index = () => {
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState([]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await classServices.getBatchDetails();
      if (response.data.success) {
        setDetails(response.data.batches || []);
      } else {
        toast.error('Failed to fetch batch details.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch batch details.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  if (loading) {
    return (
      <Card extra={'w-full sm:overflow-auto p-4'}>
        <div className="flex h-40 items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
        </div>
      </Card>
    );
  }

  return (
    <Card extra={'w-full sm:overflow-auto p-4'}>
      <div className="space-y-4">
        {details.map((batch) => {
          const courses = batch.batchStructure?.courses || [];
          const firstSchedule = batch.daySchedules?.[0];

          return (
            <div
              key={batch._id}
              className="rounded-lg border p-4 text-navy-800 shadow-sm transition-shadow duration-300 hover:shadow-md dark:text-white/70"
            >
              <div className="mb-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-800 dark:text-white">
                  {courses.length
                    ? courses.map((c) => c.courseName).join(', ')
                    : 'Course'}{' '}
                  - Batch {batch.batchNumber}
                </h2>

                {batch.isCurrent ? (
                  <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                    Current
                  </span>
                ) : (
                  <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800">
                    Past
                  </span>
                )}
              </div>

              <div className="grid gap-4 md:grid-cols-2">
                {/* Batch Details */}
                <div className="space-y-2">
                  <div className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-green-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <span>Start Date: {formatDate(batch.startDate)}</span>
                  </div>

                  <div className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-purple-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>
                      Time:{' '}
                      {firstSchedule
                        ? `${firstSchedule.startTime} - ${firstSchedule.endTime}`
                        : 'N/A'}
                    </span>
                  </div>
                </div>

                {/* Days Schedule */}
                {batch.daySchedules?.length > 0 && (
                  <div>
                    <h3 className="mb-2 text-lg font-semibold text-gray-700">
                      Class Days
                    </h3>
                    <div className="grid grid-cols-2 gap-2">
                      {batch.daySchedules.map((d) => (
                        <div
                          key={d._id}
                          className="rounded bg-gray-100 px-3 py-1 text-center text-gray-800 dark:border dark:bg-navy-800 dark:text-white"
                        >
                          {d.day}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Teacher Information */}
              {batch.teacher && (
                <div className="mt-4 border-t border-gray-200 pt-2">
                  <h3 className="text-lg font-semibold text-gray-700">
                    Instructor
                  </h3>
                  <div className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a4 4 0 00-4 4v1h8v-1a4 4 0 00-4-4z"
                      />
                    </svg>
                    <span>
                      {batch.teacher.name} ({batch.teacher.email})
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default Index;
